import Select from "react-select";
import useSelectPractices from "./hooks/useSelectPractices";

const SelectPractices = ({ onChange, selected, selectRef }) => {
  const { practices } = useSelectPractices();
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderColor: state.isFocused ? "#136C62" : provided.borderColor,
      boxShadow: state.isFocused ? "0 0 0 1px green" : provided.boxShadow,
      "&:hover": {
        borderColor: "#136C62",
      },
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor:
        state.isSelected || state.isFocused
          ? "#e0f2e9"
          : provided.backgroundColor,
      color: "black",
      "&:active": {
        backgroundColor: "#e0f2e9",
      },
    }),
    dropdownIndicator: (provided, state) => ({
      ...provided,
      color: state.isFocused ? "#136C62" : provided.color,
      "&:hover": {
        color: "#136C62",
      },
    }),
  };

  return (
    <>
      <label htmlFor="practice">Practice</label>
      <Select
        name="practice"
        onChange={onChange}
        options={practices}
        ref={selectRef}
        styles={customStyles}
      />
    </>
  );
};

export default SelectPractices;
